import { Select, Button, Space } from "antd";
import { FilterFilled } from "@ant-design/icons";
import React from "react";

export default function TableColumnDropdownSearchProps({
                                                       dataIndex,
                                                       options,
                                                       setFilterText,
                                                       setFilterColumn,
                                                       setCurrentPage,
                                                     }) {
  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }}>
        <Select
          showSearch
          allowClear
          placeholder={`Chọn ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(value) => setSelectedKeys(value ? [value] : [])}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
          options={options}
          optionFilterProp="label"
        />
        <Space>
          <Button
            type="primary"
            onClick={() => {
              confirm();
              setFilterText(selectedKeys[0]);
              setFilterColumn(dataIndex);
              setCurrentPage(1);
            }}
            size="small"
            style={{ width: 90 }}
          >
            Lọc
          </Button>
          <Button
            onClick={() => {
              setFilterText('');
              setFilterColumn('');
              setCurrentPage(1);
              clearFilters && clearFilters();
            }}
            size="small"
            style={{ width: 90 }}
          >
            reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Đóng
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <FilterFilled style={{ color: filtered ? '#1677ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      console.log('onFilter', value, record)
      return record[dataIndex]?.toString() === value;
    },
  };
}
